import React, { useEffect, useState, useRef } from 'react';
import Typical from 'react-typical';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

import ScreenHeading from '../../../utils/ScreenHeading/ScreenHeading';
import ScrollService from '../../../utils//ScrollService';
import Animations from '../../../utils//Animations';

import contactMePicture from '../../../assets/img/ContactMe/contact-me-picture.jpeg';
import loadingAnimation from '../../../assets/img/ContactMe/loading-animation.gif';

import Footer from '../Home/Footer/Footer';
import "./ContactMe.css";

export default function ContactMe ( props )
{
  let fadeInScreenHandler = ( screen ) =>
  {
    if ( screen.fadeInScreen !== props.id )
      return;
    Animations.animations.fadeInScreen( props.id );
  };

  const fadeInSubscription = ScrollService.currentScreenFadeIn.subscribe( fadeInScreenHandler );

  useEffect( () =>
  {
    return () =>
    {
      fadeInSubscription.unsubscribe();
    };
  }, [ fadeInSubscription ] );

  const [ name, setName ] = useState( '' );
  const [ email, setEmail ] = useState( '' );
  const [ message, setMessage ] = useState( '' );

  const handleName = ( e ) => { setName( e.target.value ); };
  const handleEmail = ( e ) => { setEmail( e.target.value ); };
  const handleMessage = ( e ) => { setMessage( e.target.value ); };


  const [ banner, setBanner ] = useState( '' );
  const [ bool, setBool ] = useState( false );
  const form = useRef();


  // EmailJS
  const sendEmail = ( e ) =>
  {
    e.preventDefault();

    const templateParams = { from_name: name + " " + email, to_name: "ymw0331@gmail.com", feedback: message };
    setBool( true );

    emailjs
      .send( 'service_fohqnll', 'template_neogwdl', templateParams, 'whzjofFrJvessHctn' )
      .then(
        function ( response )
        {
          if ( name.length === 0 || email.length === 0 || message.length === 0 )
          {
            const reminderMessage = "Please fill all the required fields";
            setBanner( reminderMessage );
            toast.error( reminderMessage );
            setBool( false );
          }
          else if ( response.status === 200 )
          {
            console.log( 'SUCCESS!', response.status, response.text );
            const sucessMessage = "Thank you for contacting Ming Wei, your message has been sent";
            setBanner( sucessMessage );
            toast.success( sucessMessage );
            setBool( false );
            setName( "" );
            setEmail( "" );
            setMessage( "" );
          }

        },
        function ( error )
        {
          const errorMessage = "Mssage failed to send";
          console.log( 'FAILED...', error );
          setBanner( errorMessage );
          toast.error( errorMessage );
          setBool( false );
        } );
  };

  return (
    <div>
      <div className="contact-me-container fade-in" id={ props.id || '' }>
        <div className="contact-me-bg"> </div>
        <div className="contact-inner-part d-flex flex-column">
          {/* <span className="contact-me-heading-text">Contact Me</span> */ }
          {/* <span className="contact-me-subheading-text mb-5">Lets Keep in Touch</span> */ }
          <ScreenHeading title="Contact Me" subHeading={ 'Lets Keep In Touch' } />

          <div className="contact-me-card row">

            <div className="left-contact-card col-lg-6 col-md-5 col-sm-12 px-2 py-2">

              <span className="get-in-touch mx-4 my-5"> Get in touch 💬</span>

              <div className="py-5 d-flex justify-content-center">
                <lottie-player
                  src="https://assets10.lottiefiles.com/packages/lf20_3ktmthuy.json"
                  background="transparent"
                  speed="1"
                  // style={{ width: "300px" }}
                  loop
                  autoplay
                ></lottie-player>
              </div>
            </div>

            <div className="col-lg-6 col-md-5 col-sm-12 my-auto">

              <p className='banner-text'>{ banner }</p>
              <form
                ref={ form }
                className="right-contact-card d-flex flex-column "
                onSubmit={ sendEmail }
              >
                <div className="input-group my-3 d-flex flex-column">
                  <label> Name </label>
                  <input
                    value={ name }
                    onChange={ handleName }
                    type="text"
                    placeholder="Enter your name"
                    className="input-groups"
                  />
                </div>
                <div className="input-group my-3 d-flex flex-column">
                  <label>Email </label>
                  <input
                    value={ email }
                    onChange={ handleEmail }
                    type="email"
                    placeholder="Enter your email"
                    className="input-groups"
                  />
                </div>
                <div className="input-group my-3 d-flex flex-column">
                  <label> Message </label>
                  <textarea
                    value={ message }
                    onChange={ handleMessage }
                    type="text"
                    placeholder="Enter your message"
                    className="input-groups"
                  />
                </div>
                <div className="input-group my-3 d-flex flex-column">
                  <input
                    className="btn btn-success"
                    type="submit"
                    value="Send Message"
                  />{ " " }
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
    // <div className='contact-container fade-in' id={ props.id || '' }>

    //   <div className="contact-inner-part d-flex flex-column">

    //     <ScreenHeading title="Contact Me" subHeading={ 'Lets Keep In Touch' } />

    //     <div className='contact-me-card row '>

    //       <div className='left-contact-card col-lg-6 col-md-5 col-sm-12 px-2 py-2'>

    //         {/* get-in-touch mx-4 my-5 */ }
    //         <h2 className='title'>
    //           <Typical loop={ Infinity }
    //             steps={ [
    //               "Get In Touch 💬", 2000,
    //               "Send Me An Email 📧", 2000
    //             ] } />
    //         </h2>{ '' }

    //         <a href='https://www.linkedin.com/in/ymw0331/' target="_blank" rel="noreferrer">
    //           <i className='fa fa-linkedin-square'></i>
    //         </a>
    //         <a href='https://github.com/ymw0331' target="_blank" rel="noreferrer">
    //           <i className='fa fa-github'></i>
    //         </a>
    //         <a href='https://wa.link/kz6sgq' target="_blank" rel="noreferrer">
    //           <i className='fa fa-whatsapp'></i>
    //         </a>

    //         <div className='img-background'>
    //           <h4>Send Your Email Here!</h4>
    //           {/* <img src={ contactMePicture } alt='cannot be loaded'></img> */ }
    //           <lottie-player
    //             src="https://assets10.lottiefiles.com/packages/lf20_3ktmthuy.json"
    //             background="transparent"
    //             speed="1"
    //             style={ { width: "300px" } }
    //             loop
    //             autoplay
    //           ></lottie-player>

    //         </div>
    //       </div>



    //       {/*contact-me-form  */ }
    //       <div className='contact-me-form col-lg-6 col-md-5 col-sm-12 my-auto'>
    //         <form
    //           className="right-contact-card d-flex flex-column "
    //           ref={ form }
    //           onSubmit={ sendEmail }
    //         >

    //           <p>{ banner }</p>
    //           <div className="input-group my-3 d-flex flex-column">
    //             <label htmlFor='name'>Name</label>
    //             <input
    //               type='text'
    //               onChange={ handleName }
    //               value={ name }
    //               placeholder="Enter your name"
    //               className="input-groups" />
    //           </div>

    //           <div className="input-group my-3 d-flex flex-column">
    //             <label htmlFor='email'>Email</label>
    //             <input
    //               type='email'
    //               onChange={ handleEmail }
    //               value={ email }
    //               placeholder="Enter your email"
    //               className="input-groups"
    //             />
    //           </div>

    //           <div className="input-group my-3 d-flex flex-column">
    //             <label htmlFor='message'>Message</label>
    //             <textarea type='text'
    //               onChange={ handleMessage }
    //               value={ message }
    //               placeholder="Enter your message"
    //               className="input-groups"
    //             />

    //           </div>

    //           <div className="input-group my-3 d-flex flex-column">
    //             <div className='send-btn'>
    //               <button type='submit'>
    //                 SEND { '' }
    //                 <i className='fa fa-paper-plane' />
    //                 { bool ?
    //                   ( <b className='load'>
    //                     <img src={ loadingAnimation } alt='cannot be loaded' />
    //                   </b>
    //                   ) : ( '' ) }
    //               </button>
    //             </div>
    //           </div>


    //         </form>

    //       </div>

    //     </div>


    //     <Footer />

    //   </div>
    // </div>

  );
}